import React from 'react'
import img from '../../Assete/Icon (7).svg'
import img1 from '../../Assete/Icon (8).svg'
import img2 from '../../Assete/Icon (9).svg'
import img3 from '../../Assete/Icon (10).svg'

function Counter() {
    return (
        <div className='counter_section'>
            <div className='container'>
                <div className='row m-0'>
                    <div className='col-lg-3 col-md-3 col-6'>
                        <div className='counter_item'>
                            <img className='mt-1 me-2' src={img} alt='...' />
                            <div >
                                <h3 className='mb-0 mt-0'>500+</h3>
                                <p className='mb-0'>Active Jobs</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-6'>
                        <div className='counter_item'>
                            <img className='mt-1 me-2' src={img1} alt='...' />
                            <div >
                                <h3 className='mb-0 mt-0'>1000+</h3>
                                <p className='mb-0'>Scholarships</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-6'>
                        <div className='counter_item'>
                            <img className='mt-1 me-2' src={img2} alt='...' />
                            <div >
                                <h3 className='mb-0 mt-0'>2000+</h3>
                                <p className='mb-0'>Companies</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-6'>
                        <div className='counter_item'>
                            <img className='mt-1 me-2' src={img3} alt='...' />
                            <div >
                                <h3 className='mb-0 mt-0'>300+</h3>
                                <p className='mb-0'>Success Stories</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Counter